import { render } from "./VerticalNavSubList.vue?vue&type=template&id=f1f37d30&scoped=true&ts=true"
import script from "./VerticalNavSubList.vue?vue&type=script&lang=ts"
export * from "./VerticalNavSubList.vue?vue&type=script&lang=ts"

import "./VerticalNavSubList.vue?vue&type=style&index=0&id=f1f37d30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f37d30"]])

export default __exports__